import { Dialog, DialogClose, DialogTitle } from "@suse-o11y/dialog";
import { IconClose, IconErrorOutlined } from "@suse-o11y/icons";
import { isError } from "@suse-o11y/is-error";
import React, { type FC } from "react";

import { isHTTPError } from "../../generic/request";
import { Markdown } from "../react/markdown/Markdown";

export interface ErrorDetailsDrawerProps {
	error: unknown;
}

export const ErrorDetailsDrawer: FC<ErrorDetailsDrawerProps> = ({ error }) => (
	<Dialog className="drawer/dialog drawer-narrow">
		<header className="drawer-header">
			<IconErrorOutlined className="size-5 text-core-text-alert-primary" />

			<DialogTitle className="drawer-title">
				{isHTTPError(error) ? error.statusText || "Unknown Error" : "Error"}
			</DialogTitle>

			<DialogClose aria-label="Close" className="button button-square ml-auto">
				<IconClose className="size-3" />
			</DialogClose>
		</header>

		<section className="drawer-body space-y-6">
			<p className="m-0 text-13">{isError(error) ? error.message : "Unknown Error"}</p>

			{isHTTPError(error) && error.data != null && <Details markdown={JSON.stringify(error.data)} title="Error Data" />}

			{isHTTPError(error) && error.apiErrors != null && error.apiErrors.length > 0 && (
				<Details
					markdown={["```json", JSON.stringify(error.apiErrors, null, 2), "```"].join("\n")}
					title="Error Trace"
				/>
			)}
		</section>
	</Dialog>
);

const Details: React.FC<{
	title: string;
	markdown: string;
}> = ({ title, markdown }) => (
	<div>
		<h3 className="font-medium text-15/5.5 text-core-text-neutral-primary">{title}</h3>

		<Markdown
			className="prose-pre:mt-4 prose-pre:rounded-sm! prose-pre:border-core-stroke-alert-primary! prose-pre:bg-core-fill-alert-secondary! prose-pre:p-3!"
			copyCodeToClipboard
			text={markdown}
			trimText
		/>
	</div>
);
